import type { QueryKey } from '@tanstack/react-query';
import { PORTAL_KEYS } from '@/domains/sales/portal/api/usePortal';
import { WIZARD_KEYS } from '@/domains/sales/wizard/api/useWizard';

/** Qué se vuelve a pedir cuando el canal avisa, según la pantalla que el vendedor tiene abierta. */

/** Prefijo de la agenda: alcanza a la del vendedor de la sesión sin conocer su `sellerId`. */
export const PROSPECTS_LIST_KEY: QueryKey = WIZARD_KEYS.prospects('').slice(0, 2);

/** La venta que la ficha del prospecto abierta muestra al lado de la tabla. */
const PROSPECT_SALE_KEYS: readonly QueryKey[] = [
    WIZARD_KEYS.session('').slice(0, 2),
    WIZARD_KEYS.activeSession('').slice(0, 2),
];

export const RECENT_SALES_KEY: QueryKey = PORTAL_KEYS.recentSales;
export const SELLER_KPIS_KEY: QueryKey = PORTAL_KEYS.kpis;
export const SELLER_ALERTS_KEY: QueryKey = PORTAL_KEYS.sellerAlerts;

const NONE: readonly QueryKey[] = Object.freeze([]);

/** Las cuatro lecturas del Home que cambian cuando una venta se mueve. */
const SELLER_HOME_KEYS: readonly QueryKey[] = [
    SELLER_KPIS_KEY,
    RECENT_SALES_KEY,
    SELLER_ALERTS_KEY,
    PROSPECTS_LIST_KEY,
];

/**
 * Lista blanca por sección. En Clientes solo cuenta la pestaña Prospectos (y su contador); Catálogo,
 * Mi tienda y KYC pendientes no pintan el estado de las ventas, así que no entran.
 */
const SECTION_KEYS = new Map<string, readonly QueryKey[]>([
    ['customers', [PROSPECTS_LIST_KEY, ...PROSPECT_SALE_KEYS]],
    ['my-sales', [RECENT_SALES_KEY]],
]);

const PORTAL_PREFIX = '/sales';

/** Queries a invalidar en esa ruta, en orden. Vacío = esa pantalla no se refresca. */
export function refreshKeysFor(pathname: string): readonly QueryKey[] {
    if (pathname !== PORTAL_PREFIX && !pathname.startsWith(`${PORTAL_PREFIX}/`)) return NONE;

    const section = pathname.slice(PORTAL_PREFIX.length).replace(/^\/|\/$/g, '');
    if (section === '') return SELLER_HOME_KEYS;
    return SECTION_KEYS.get(section) ?? NONE;
}
